import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "./utils";

export function StatsBar() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/stats/daily`).then((r) => setStats(r.data)).catch(() => {});
    const t = setInterval(() => {
      axios.get(`${API}/stats/daily`).then((r) => setStats(r.data)).catch(() => {});
    }, 30000);
    return () => clearInterval(t);
  }, []);

  const s = stats || {};

  const statBoxStyle = {
    display: "flex", flexDirection: "column", alignItems: "center",
    padding: "6px 14px", minWidth: 90,
  };
  const statValue = {
    fontSize: 22, fontWeight: 700, color: "#FFF",
    fontFamily: "'IBM Plex Mono', monospace", lineHeight: 1,
  };
  const statLabel = {
    fontSize: 10, color: "#8CF", fontWeight: 600,
    textTransform: "uppercase", letterSpacing: 0.5, marginTop: 2,
    fontFamily: "'IBM Plex Sans', sans-serif", whiteSpace: "nowrap",
  };

  return (
    <div data-testid="vac-stats-bar" style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(180deg, #1a2a3a 0%, #0d1820 100%)",
      borderBottom: "2px solid #00BFFF", padding: "4px 0", gap: 2, flexWrap: "wrap",
    }}>
      <div style={statBoxStyle}>
        <span style={statValue}>{s.avg_response_time || 0}<span style={{ fontSize: 12, color: "#8CF" }}>m</span></span>
        <span style={statLabel}>Avg Response</span>
      </div>
      <div style={{ width: 1, height: 36, background: "#334" }} />
      <div style={statBoxStyle}>
        <span style={statValue}>{s.avg_81_time || 0}<span style={{ fontSize: 12, color: "#8CF" }}>m</span></span>
        <span style={statLabel}>Avg 81 Time</span>
      </div>
      <div style={{ width: 1, height: 36, background: "#334" }} />
      <div style={statBoxStyle}>
        <span style={statValue}>{s.total_dispatched || 0}</span>
        <span style={statLabel}>Calls Today</span>
      </div>
      <div style={{ width: 1, height: 36, background: "#334" }} />
      <div style={statBoxStyle}>
        <span style={{ ...statValue, color: "#00FF88" }}>{s.in_service_bls || 0}</span>
        <span style={statLabel}>BLS</span>
      </div>
      <div style={{ width: 1, height: 36, background: "#334" }} />
      <div style={statBoxStyle}>
        <span style={{ ...statValue, color: "#FF6644" }}>{s.in_service_als || 0}</span>
        <span style={statLabel}>ALS</span>
      </div>
      <div style={{ width: 1, height: 36, background: "#334" }} />
      <div style={statBoxStyle}>
        <span style={{ ...statValue, color: "#FFCC00" }}>{s.in_service_supv || 0}</span>
        <span style={statLabel}>SUPV</span>
      </div>
      <div style={{ width: 1, height: 36, background: "#334" }} />
      <div style={statBoxStyle}>
        <span style={{ ...statValue, color: "#CC88FF" }}>{s.in_service_easv || 0}</span>
        <span style={statLabel}>EASV</span>
      </div>
      <div style={{ width: 1, height: 36, background: "#334" }} />
      <div style={statBoxStyle}>
        <span style={{ ...statValue, color: "#00BFFF" }}>{s.active_vacs || 0}</span>
        <span style={statLabel}>Active VACs</span>
      </div>
    </div>
  );
}
